// import * as ICONS from 'constants/icons';
import { PERMISSIONS_GENERAL, PERMISSIONS_SUBSCRIBED_PLAN } from 'constants/permissions';
import { SCOPES } from 'constants/roles';

export default [
  {
    label: 'label.participants',
    name: 'participants-list',
    url: '/professional/persons/participants/',
    navigationIcon: 'far fa-users',
    scope: SCOPES.PROFESSIONAL,
    requiredSubscribedFeature: PERMISSIONS_SUBSCRIBED_PLAN.PARTICIPANTS,
    pages: [
      {
        type: 'section',
        navigationIcon: 'far fa-address-card',
        name: 'participant-profile',
        label: 'label.profile',
        url: '/professional/persons/participants/{id}/profile/',
        pages: [
          {
            type: 'item',
            navigationIcon: '',
            name: 'participant-profile',
            url: '/professional/persons/participants/{id}/profile/personal-information',
            label: 'label.personal_information',
          },
          {
            type: 'item',
            navigationIcon: '',
            name: 'participant-consultation',
            label: 'label.consultation',
            url: '/professional/persons/participants/{id}/profile/consultation',
          },
          {
            type: 'item',
            navigationIcon: 'far fa-portrait',
            name: 'participant-profile-picture',
            url: '/professional/persons/participants/{id}/profile/picture',
            label: 'label.profile_picture',
          },
          // {
          //   type: 'item',
          //   navigationIcon: '',
          //   name: 'participant-health-related-semantic',
          //   label: 'label.health_related_semantic',
          //   url: '/professional/persons/participants/{id}/profile/semantic-information/',
          // },
        ],
      },
      {
        label: 'label.programs',
        navigationIcon: 'far fa-code-branch',
        name: '',
        type: 'section',
        url: '/professional/persons/participants/{id}/related-content/',
        scope: SCOPES.PROFESSIONAL,
        pages: [
          {
            type: 'item',
            navigationIcon: 'far fa-calendar-alt',
            name: 'participant-assigned-programs',
            label: 'label.assigned_programs',
            url: '/professional/persons/participants/{id}/related-content/assigned-programs',
          },
          // {
          //   label: 'label.messages',
          //   navigationIcon: 'far fa-comment',
          //   name: 'dish-main-details-view',
          //   type: 'item',
          //   url: '/stuff-to-eat/dishes-aaa',
          // },
          // {
          //   label: 'label.questionaries',
          //   navigationIcon: 'far fa-question',
          //   name: 'dish-main-details-view',
          //   type: 'item',
          //   url: '/stuff-to-eat/dishes-aaa',
          // },
        ],
      },
      {
        type: 'section',
        navigationIcon: 'far fa-chart-bar',
        name: 'participant-evolution-dashboard',
        label: 'label.participant_evolution',
        url: '/professional/persons/participants/{id}/evolution',
        pages: [
          {
            type: 'item',
            navigationIcon: 'far fa-chart-bar',
            name: 'participant-evolution-dashboard',
            label: 'label.dashboard',
            url: '/professional/persons/participants/{id}/evolution/dashboard',
          },
          {
            type: 'item',
            navigationIcon: 'far fa-cog',
            name: 'participant-evolution-settings-general',
            label: 'label.evolution_settings',
            url: '/professional/persons/participants/{id}/evolution/settings-general',
          },
          {
            type: 'item',
            navigationIcon: 'far fa-list-ul',
            name: 'participant-evolution-settings-tracked-measurements',
            label: 'label.measurement_tracking',
            url: '/professional/persons/participants/{id}/evolution/settings-tracked-measurements',
          },
        ],
      },
      {
        type: 'section',
        label: 'label.settings',
        name: 'participant-settings',
        navigationIcon: 'fas fa-sliders-v',
        url: '/professional/persons/participants/{id}/settings',
        pages: [
          {
            label: 'label.status',
            name: 'participant-status',
            navigationIcon: '',
            url: '/professional/persons/participants/{id}/settings/status',
          },
          {
            label: 'label.delete',
            class: 'is-delete',
            name: 'participant-delete',
            navigationIcon: '',
            requiredPermissionsGeneral: PERMISSIONS_GENERAL.DELETE,
            url: '/professional/persons/participants/{id}/settings/delete',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/navigations/person/navigation-person-participant.js